export function Constants() {
  angular.module("classkickApp").constant("constants", {
    version: "5.306.0-6622c9b",
    backend: "webservices",
    projectId: "classkick-907",
  })
}
